"use strict";

exports.__esModule = true;
exports.focusStyles = void 0;

const focusStyles = ({
  borderRadius = 'medium',
  borderWidth = 'x-small',
  theme
}) => {
  const borderWidthValue = theme?.borderWidths?.[borderWidth];
  const offset = borderWidthValue === 0 ? 2 : borderWidthValue + 2;
  const negativeOffset = `${offset * -1}px`;
  return {
    '&:after': {
      borderRadius,
      bottom: negativeOffset,
      boxShadow: `0 0 0 ${negativeOffset} ${theme?.colors?.primary?.[200]}`,
      content: '""',
      display: 'block',
      left: negativeOffset,
      pointerEvents: 'none',
      position: 'absolute',
      right: negativeOffset,
      top: negativeOffset,
      transitionDuration: 'base',
      transitionProperty: 'common',
      zIndex: 1
    },
    '&:focus, &[data-focus]': {
      '&::after': {
        boxShadow: `0 0 0 2px ${theme?.colors?.primary?.[200]}`,
        outline: `1px solid transparent`
      }
    },
    position: 'relative',
    WebkitTapHighlightColor: 'transparent'
  };
};

exports.focusStyles = focusStyles;